import axios, { AxiosResponse } from "axios";

const responseBody = (response: AxiosResponse) => response.data;

export const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_DSC_SERVICE_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});

export const requests = {
  get: (url: string) =>
    axios
      .get(`${process.env.REACT_APP_DSC_SERVICE_URL}${url}`)
      .then(responseBody),
  post: (url: string, body: {}, config?: {}) =>
    axios
      .post(`${process.env.REACT_APP_DSC_SERVICE_URL}${url}`, body, config)
      .then(responseBody),
  put: (url: string, body?: {}) =>
    axios
      .put(`${process.env.REACT_APP_DSC_SERVICE_URL}${url}`, body)
      .then(responseBody),
  patch: (url: string, body: {}) =>
    axios
      .patch(`${process.env.REACT_APP_DSC_SERVICE_URL}${url}`, body)
      .then(responseBody),

  delete: (url: string, body?: {}) => {
    return axios
      .delete(`${process.env.REACT_APP_DSC_SERVICE_URL}${url}`, body)
      .then(responseBody);
  },
};
